import React from 'react';
import { Link } from 'react-router-dom';

  export default class Nav extends React.Component {

    signOut = () => this.props.signOut().then(this.props.history.push('/'));

    render() {    
      return (
        <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
          <Link className="navbar-brand mb-0 h1" to="/" > Garden </Link>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">

            <ul className="navbar-nav">
              <li className="nav-item" data-toggle="collapse" data-target="#navbarNav">
                <Link className="nav-link"  to="/" > Home</Link>
              </li>
              <li className="nav-item" data-toggle="collapse" data-target="#navbarNav">
                <Link className="nav-link" to="/info" > Info</Link>
              </li>
              <li className="nav-item" data-toggle="collapse" data-target="#navbarNav">
                <Link className="nav-link" to="/sensors" > Sensors</Link>
              </li>
              <li className="nav-item" data-toggle="collapse" data-target="#navbarNav">
                <Link className="nav-link" to="/create-sensor" > Create Sensor</Link>
              </li>
              
            </ul>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item ml-auto">
                <Link className="btn btn-outline-secondary" to="/" onClick={ this.signOut } > Logout</Link>
              </li>
            </ul>

          </div>
        </nav>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/nav.js